<div style="display: inline-flex; align-items: center; flex-wrap: wrap">
  <ng-container
    *ngFor="let entry of getSelected(); let i = index; let iCount = count; trackBy: trackOptionBy"
    style="margin-left: 8px; display: flex; flex-wrap: wrap"
  >
    <ng-container *ngIf="entry[0].type !== 'variable'">
      <ion-button class="filter-button-section filter-button-start" color="dark" fill="clear" [disabled]="disabled">
        <ion-icon
          [name]="entry[0].icon"
          *ngIf="entry[0].icon"
          class="left-button-icon"
          style="font-size: 0.75rem; color: var(--ion-color-step-600)"
        ></ion-icon>
        <span style="font-weight: 500" class="hidden-sm">{{ entry[0].label }}:</span>
      </ion-button>
    </ng-container>
    <ng-container *ngIf="entry[0].type === 'date'">
      <ion-button
        color="dark"
        fill="clear"
        class="filter-button-section filter-button-end"
        (click)="removeFilter(entry[0], 1); removeFilter(entry[0], 0)"
        [disabled]="disabled"
      >
        <span class="filter-label">
          {{ entry[1][0]?.label }}{{ entry[1][1]?.label ? ' to ' : '' }}{{ entry[1][1]?.label }}
          <ion-icon name="close-outline" style="margin-left: 2px; font-size: 0.7rem"></ion-icon>
        </span>
      </ion-button>
    </ng-container>
    <ng-container *ngIf="entry[0].type !== 'date' && entry[0].type !== 'variable'">
      <ng-container *ngFor="let value of entry[1]; let j = index; let jCount = count; trackBy: trackValueBy">
        <ion-button
          color="dark"
          fill="clear"
          class="filter-button-section"
          [ngClass]="{ 'filter-button-end': j >= jCount - 1, 'filter-button-connector': j < jCount - 1 }"
          (click)="removeFilter(entry[0], j)"
          [disabled]="disabled"
        >
          <span class="filter-label">
            {{ value.label }}
            <ion-icon name="close-outline" style="margin-left: 1px; font-size: 0.7rem; margin-top: -2px"></ion-icon>
          </span>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="filter-button-section filter-button-connector"
          (click)="toggleGrouping(entry[0])"
          *ngIf="j < entry[1].length - 1"
          [disabled]="disabled"
        >
          <span
            class="connector-label"
            [ngClass]="{
              'clickable-connector-label':
                entry[0].id === 'tags.id' || entry[0].id === 'customer.tags.id' || entry[0].id === 'account.tags.id'
            }"
          >
            {{ entry[0].type === 'date' ? 'to' : entry[0].grouping ?? 'or' }}
          </span>
        </ion-button>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="entry[0].type === 'variable'">
      <ng-container *ngFor="let value of entry[1]; let j = index; let jCount = count; trackBy: trackValueBy">
        <ion-button
          color="dark"
          fill="clear"
          class="filter-button-section filter-button-start"
          [disabled]="disabled"
          [title]="value.additionalFields.ticketTypeName ?? value.label"
        >
          <ion-icon
            [name]="entry[0].icon"
            *ngIf="entry[0].icon"
            class="left-button-icon"
            style="font-size: 0.75rem; color: var(--ion-color-step-600)"
          ></ion-icon>
          <span style="font-weight: 500" class="hidden-sm">{{ value.label }}:</span>
        </ion-button>

        <ion-button color="dark" fill="clear" class="filter-button-section no-x-borders" [disabled]="disabled">
          <!-- Single and multi-select with internal options -->
          <div
            *ngIf="
              !value.additionalFields?.externalSelect &&
              (value.additionalFields?.type === 'single-select' || value.additionalFields?.type === 'multi-select')
            "
          >
            <ion-select
              class="filter-label"
              [placeholder]="value.additionalFields?.type === 'single-select' ? 'Select an option' : 'Select options'"
              interface="popover"
              (ionChange)="updateCustomFieldFilter($event)"
              [multiple]="value.additionalFields?.type === 'multi-select'"
              [(ngModel)]="value.values"
              [compareWith]="compareFilterValues"
            >
              <ion-select-option *ngFor="let option of value.additionalFields.options" [value]="option">
                {{ option }}
              </ion-select-option>
            </ion-select>
          </div>
          <!-- Single select with external options -->
          <div *ngIf="value.additionalFields?.type === 'single-select' && value.additionalFields?.externalSelect">
            <ion-button
              fill="clear"
              class="filter-label"
              (click)="showExternalSelectOptionsForCustomField($event, value)"
            >
              {{ value.values?.label || 'Select option' }}
            </ion-button>
          </div>
          <!-- Multi select with external options -->
          <div *ngIf="value.additionalFields?.type === 'multi-select' && value.additionalFields?.externalSelect">
            <ion-label text-wrap style="margin: 0">
              <ion-chip
                mode="ios"
                color="primary"
                class="chip tag-chip"
                *ngFor="let selectedOption of value.values"
                (click)="removeExternalSelectOption(value, selectedOption)"
              >
                <ion-label>{{ selectedOption.label }}</ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                class="chip tag-chip"
                style="border: none !important"
                (click)="showExternalSelectOptionsForCustomField($event, value)"
              >
                <ion-label>
                  <span>Add...</span>
                </ion-label>
              </ion-chip>
            </ion-label>
          </div>
          <!-- Checkbox -->
          <div *ngIf="value.additionalFields?.type === 'checkbox'">
            <ion-checkbox [(ngModel)]="value.values" (ionChange)="updateCustomFieldFilter($event)"></ion-checkbox>
            <ion-label>{{ value.additionalFields.label }}</ion-label>
          </div>
          <!-- User select -->
          <div *ngIf="value.additionalFields?.type === 'user-select'">
            <ion-button fill="clear" class="filter-label" (click)="showUserSelectionForCustomField($event, value)">
              {{ value.values?.name?.trim() || value.values?.email || 'Select user' }}
            </ion-button>
          </div>
          <!-- Multi user select -->
          <div *ngIf="value.additionalFields?.type === 'multi-user-select'">
            <ion-label text-wrap style="margin: 0">
              <ion-chip
                mode="ios"
                color="primary"
                class="chip tag-chip"
                *ngFor="let selectedUser of value.values"
                (click)="removeUserFromMultiSelect(value, selectedUser)"
              >
                <ion-label>{{ selectedUser.name?.trim() || selectedUser.email }}</ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                class="chip tag-chip"
                style="border: none !important"
                (click)="showUserSelectionForCustomField($event, value)"
              >
                <ion-label>
                  <span>Add...</span>
                </ion-label>
              </ion-chip>
            </ion-label>
          </div>
          <!-- Date select -->
          <div *ngIf="value.additionalFields?.type === 'date'">
            <ion-button fill="clear" class="filter-label" (click)="changeTicketTypeFieldDate(value)">
              {{ value.values ? (value.values | date: 'MM/dd/yyyy') : 'Select date' }}
            </ion-button>
          </div>
        </ion-button>

        <ion-button
          color="dark"
          fill="clear"
          class="filter-button-section filter-button-end"
          (click)="removeFilter(entry[0], j)"
          [disabled]="disabled"
          style="padding: 7px 7px 7px 0px"
        >
          <ion-icon name="close-outline" style="font-size: 0.7rem; color: var(--ion-color-primary)"></ion-icon>
        </ion-button>
      </ng-container>
    </ng-container>
  </ng-container>

  <ion-button
    fill="clear"
    color="dark"
    [disabled]="disabled"
    (click)="addFilter()"
    style="--padding-start: 8px; --padding-end: 8px"
    class="btn-small"
    [hidden]="maxFilters && getSelected()?.length >= maxFilters"
  >
    <ion-icon name="filter-outline" class="left-button-icon"></ion-icon>
    Filter
  </ion-button>

  <ion-button
    fill="clear"
    color="dark"
    [disabled]="disabled"
    (click)="showSaveOptions()"
    *ngIf="savedFilterView && getSelected()?.length"
    class="hidden-sm btn-small"
    style="--padding-start: 8px; --padding-end: 8px"
  >
    Save...
  </ion-button>
</div>

<ion-modal [isOpen]="showSavedFilterModal" class="saved-filter-modal" (willDismiss)="onDismissSaveFilterModal()">
  <ng-template>
    <ion-header class="modal-header">
      <ion-toolbar>
        <div class="modal-title">
          <h3>Create Saved Filter</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button fill="clear" shape="round" class="close-button" (click)="onDismissSaveFilterModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-input [(ngModel)]="savedFilterName" class="input-field" placeholder="Name your saved filter"> </ion-input>
      <ion-list class="transparent-bg">
        <ion-item>
          <ion-label slot="start"> Share this filter with your team? </ion-label>
          <label class="switch" slot="end">
            <input type="checkbox" [(ngModel)]="savedFilterShouldShare" />
            <span class="slider"></span>
          </label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <div style="padding: 15px">
        <ion-button (click)="saveFilter(true)" class="save-button" [disabled]="!savedFilterName || isSaving">
          Save
        </ion-button>
        <ion-button fill="clear" color="dark" (click)="onDismissSaveFilterModal()"> Cancel </ion-button>
      </div>
    </ion-footer>
  </ng-template>
</ion-modal>
